<template>
	<div>
		<!-- Desktop hero text portaled into hero -->
		<Portal v-if="desktopHeroText" to="hero">
			<slot name="desktop" :text="desktopHeroText">
				<OaoTitle class="is-desktop">{{ desktopHeroText }}</OaoTitle>
			</slot>
		</Portal>

		<!-- Mobile hero text rendered inline -->
		<slot name="mobile" :text="mobileHeroText" v-if="mobileHeroText">
			<OaoTitle :isSmall="true" class="is-mobile">{{ mobileHeroText }}</OaoTitle>
		</slot>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Portal } from 'portal-vue';
import OaoTitle from '@/components/OaoTitle';

export default {
	name: 'ConfigurableHeroText',
	components: {
		Portal,
		OaoTitle
	},
	computed: {
		...mapGetters('config', ['getHeroTextForPage']),
		heroText() {
			// Get hero text for current page using route name
			if (!this.$route || !this.$route.name) {
				return { desktopHeroText: null, mobileHeroText: null };
			}
			return this.getHeroTextForPage(this.$route.name);
		},
		desktopHeroText() {
			return this.heroText.desktopHeroText;
		},
		mobileHeroText() {
			return this.heroText.mobileHeroText;
		}
	}
};
</script>
